













































import {Component, Watch} from "vue-property-decorator";
import {WarehouseStore} from "@/modules/warehouses/store";
import {Lading} from "@/interfaces/entity";
import {PartnerType} from "@/enums/type";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {debounce, union} from 'lodash';
import PLDeliveryPrint from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryPrint/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import PLTranshipmentPrint
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentPrint/index.vue";
import {listBillLadingByPickingListTranshipmentCode} from "@/modules/pickinglisttranshipment/services";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import BillLadingSuggestConfirmToTable
    from "@/modules/warehouses/shared/components/BillLadingSuggestConfirmToTable/index.vue";
import cloneDeep from 'lodash/cloneDeep'

const form = {
    ladingRowGuids: [],
    // confirmBoxQuantity: undefined,
    pickingListTranshipmentCode: "",
    confirmNote: ""
};
@Component({
    name: "CreateConfirmedTranshipment",
    components: {
        BillLadingSuggestConfirmToTable,
        AInputBarCode,
        PLTranshipmentPrint,
        PostOfficeSelector,
        PartnerSelector,
        PLDeliveryPrint
    }
})
export default class extends mixins(CommonMixin) {
    PartnerType = PartnerType;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tỉnh đến",
            dataIndex: "locationTo.province.name",
            key: "locationToProvince",
            width: 120,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "weightTemp",
            key: "weightTemp",
            width: 100,

        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            width: 80,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "freightService.serviceCode",
            key: "ladingFreightService",
            width: 120,
            ellipsis: true
        },
        // {
        //     title: "DV_GTGT",
        //     dataIndex: "freightService.serviceCode",
        //     key: "ladingFreightServiceAdd",
        //     width: 100
        // },
        {
            title: "Thu tiền NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            width: 150,
            ellipsis: true
        }
    ];
    printObj = {
        id: "picking-list-transhipment-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };
    form = cloneDeep(form);
    ladingCode = "";
    isSubmitting = false;

    created() {
        WarehouseStore.clearStockInLadings();
    }

    get totalLading() {
        return WarehouseStore.stockInLadingIds.length;
    }

    get billLadings() {
        return WarehouseStore.stockInLadingIds.map((id: string, index) => ({
            ...WarehouseStore.stockInLadings[id],
            stt: index + 1
        }));
    }

    // @Watch("form.ladingRowGuids")
    // onLadingRowGuids(val: any) {
    //     this.form.confirmBoxQuantity = (val || []).reduce((quantity: number, currentId: string) => {
    //         const billLading = WarehouseStore.stockInLadings[currentId];
    //         return (billLading?.boxQuantity || 0) + quantity;
    //     }, 0)
    // }

    async onChangePickingListCode($evt: any) {
        this.form.pickingListTranshipmentCode = $evt?.target?.value;
        if (!this.form.pickingListTranshipmentCode) return;
        this.handleChangePickingListCode(this.form.pickingListTranshipmentCode, this)
    }

    handleChangePickingListCode = debounce(async (pickingListCode: string, vm: any) => {
        try {
            const {data} = await listBillLadingByPickingListTranshipmentCode(pickingListCode);
            WarehouseStore.setStockInLadings(vm.getProp(data, 'datas', []) as any);
        } catch (e) {
            this.$message.error(`${e.response?.data?.message || "Đã xảy ra lỗi"}`);
        }
    }, 500);

    onChangeLadingCode($evt: any) {
        const ladingCode = $evt.target.value;
        if (!ladingCode) return;
        this.handleChangeLadingCode(ladingCode, this);
    }

    handleChangeLadingCode = debounce(async (ladingCode: string, vm: any) => {
        try {
            const {data} = await listBillLadingByPickingListTranshipmentCode(vm.form.pickingListTranshipmentCode, ladingCode);
            const lading: Lading = vm.getProp(data, 'datas[0]');
            if (!lading) {
                vm.$message.error("Vận đơn không nằm trong bảng kê này");
                return;
            }
            vm.form.ladingRowGuids = union(vm.form.ladingRowGuids, [lading.rowGuid]) as any;
        } catch (e) {
            this.$message.error(`${e.response?.data?.message || "Đã xảy ra lỗi"}`);
        } finally {
            vm.ladingCode = "";
        }
    }, 500);

    async confirmTranshipment() {
        if (!this.isValidConfirm()) return;
        try {
            this.isSubmitting = true;
            await WarehouseStore.confirmTranshipment(this.form);
            this.$message.success("Xác nhận thành công");
            this.resetForm();
        } catch (e) {
            this.$message.error({content: e.response?.data?.message || "Đã có lỗi"})
        } finally {
            this.isSubmitting = false;
        }
    }

    isValidConfirm() {
        if (!this.form.ladingRowGuids.length) {
            this.$message.error({content: "Quét vận đơn để xác nhận"});
            return false;
        }
        // if (!this.form.confirmBoxQuantity) {
        //     this.$message.error({content: "Nhập số kiện nhận"});
        //     return false;
        // }
        if (!this.form.pickingListTranshipmentCode) {
            this.$message.error({content: "Quét bảng kê để xác nhận"});
            return false;
        }
        return true;
    }

    onSelectChange(selectedRowKeys: number[]) {
        this.form.ladingRowGuids = selectedRowKeys as any;
    }

    resetForm() {
        this.form = cloneDeep(form);
    }
}
